import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    show: false,
    loading: false,
    soundEnabled: true,
    globalAddress:'',
    islogin:false,
    vcode:''
  },
  getters: {
    // 获取当前开关状态
    isSoundEnabled: (state) => state.soundEnabled
  },
  mutations: {
    handleShow(state, show) {
      state.show = show;
      if (show) {
        state.loading = true
      }
    },
    handleLoading(state, loading) {
      state.loading = loading

    }
  },
  actions: {

  },
  modules: {

  },
});
